import styled from 'styled-components';

const PhoneWrapper = styled.div`
  background-color: #00bcd4;
  height: 60px;
  border-radius: 50%;
  margin: auto;
  width: 60px;
  text-align: center;
  display: flex;
  i {
    margin: auto;
  }
`;
const PhoneLinkWrapper = styled.a`
  margin: auto;
  font-size: 26px;
  margin-top: 24px;
  text-align: center;
  display: flex;
  &:hover {
    color: black;
  }
`;

export { PhoneWrapper, PhoneLinkWrapper };
